import { createRoute } from '@tanstack/react-router';
import { Footer } from 'components/Footer';
import { Header } from 'components/Header';
import { ContactUsSection } from 'components/sections/ContactUsSection';
import { FAQsSection } from 'components/sections/FAQsSection';
import { FeaturesExtraSection } from 'components/sections/FeaturesExtraSection';
import { FeaturesSection } from 'components/sections/FeaturesSection';
import { ProductSection } from 'components/sections/ProductSection';
import { RouterKey } from 'consts';
import { useLanguage } from 'context/language.context';
import { cn } from 'lib/utils';
import { motion } from 'motion/react';
import { rootRoute } from 'router';

export const HomePage = () => {
  const { direction } = useLanguage();

  return (
    <>
      <Header />
      <main className="pt-20">
        <ProductSection />
        <FeaturesSection />
        <FeaturesExtraSection />
        <FAQsSection />
        <div dir={'ltr'} className="relative w-full overflow-x-hidden">
          <motion.img
            initial={{ x: 0 }}
            animate={{ x: '-100%' }}
            transition={{ type: 'tween', ease: 'linear', duration: 35, repeat: Infinity }}
            className={cn(
              'top-0 left-0 min-w-[1851px] max-w-[1851px] min-h-[208px] object-cover',
              direction === 'rtl' && 'scale-x-[-1]',
            )}
            src="assets/curved-pattern-bg.png"
            alt="curved-pattern-bg"
          />
          <motion.img
            initial={{ x: '100%' }}
            animate={{ x: 0 }}
            transition={{ type: 'tween', ease: 'linear', duration: 35, repeat: Infinity }}
            className={cn(
              'absolute top-0 left-0 min-w-[1851px] max-w-[1851px] min-h-[208px] object-cover',
              direction === 'rtl' && 'scale-x-[-1]',
            )}
            src="assets/curved-pattern-bg.png"
            alt="curved-pattern-bg"
          />
        </div>

        <ContactUsSection />
      </main>
      <Footer />
    </>
  );
};

export const homePageRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: RouterKey.HOME_PAGE,
  component: HomePage,
});
